"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var repeatString_1 = require("../tools/repeatString");
var TerrainTypes_1 = require("../TerrainTypes");
var rand_1 = require("../tools/rand");
var Map = /** @class */ (function () {
    function Map(width, height) {
        this.data = [];
        for (var y = 0; y < height; y++) {
            this.data[y] = new Array(width);
        }
        this.width = width;
        this.height = height;
        // todo: move this to player?
        this.location = {
            x: 0,
            y: 0,
            facing: "right"
        };
    }
    Map.prototype.evaluateSpawn = function () {
        // todo add random spawn
        var spawn;
        do {
            this.location = {
                x: rand_1.getRandomInt(0, this.width - 1),
                y: rand_1.getRandomInt(0, this.height - 1),
                facing: 'right'
            };
            spawn = this.getAt(this.location.x, this.location.y);
        } while (spawn.terrain !== TerrainTypes_1.TerrainTypes.Earth);
        // mark spawn point
        this.safeWrite(this.location.x, this.location.y, TerrainTypes_1.TerrainTypes.Spawn);
        return this.location;
    };
    Map.prototype.print = function () {
        var e_1, _a;
        var b = "+" + repeatString_1.repeatString('-', (this.data[0].length * 2) - 1) + "+";
        console.log(b);
        try {
            for (var _b = __values(this.data), _c = _b.next(); !_c.done; _c = _b.next()) {
                var row = _c.value;
                console.log("|" + row.map(function (e) { return e.terrain; }).join('|') + "|");
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        console.log(b);
    };
    Map.prototype.getAt = function (x, y) {
        return this.data[y][x];
    };
    Map.prototype.move = function (direction) {
        var newLoc = Object.assign({}, this.location);
        switch (direction) {
            case "left":
                newLoc.x--;
                newLoc.facing = 'left';
                break;
            case "right":
                newLoc.x++;
                newLoc.facing = 'right';
                break;
            case "up":
                newLoc.y--;
                break;
            case "down":
                newLoc.y++;
                break;
        }
        var mapAtNewLocation = this.getAt(newLoc.x, newLoc.y);
        if (mapAtNewLocation.terrain === TerrainTypes_1.TerrainTypes.Void) {
            return {
                hasMoved: false
            };
        }
        this.location = newLoc;
        return {
            hasMoved: true,
            terrain: mapAtNewLocation.terrain
        };
    };
    Map.prototype.getViewport = function (size) {
        if (size === void 0) { size = 16; }
        if (size % 2 > 0) {
            throw new Error('Size has to be power of 2');
        }
        var h = Math.round(size / 2);
        var yl = this.location.y - h;
        var yh = this.location.y + h;
        var xl = this.location.x - h;
        var xh = this.location.x + h;
        if (xh > this.width) {
            xh = this.width;
            xl = this.width - size;
        }
        if (xl < 0) {
            xl = 0;
            xh = size;
        }
        if (yh > this.height) {
            yh = this.height;
            yl = this.height - size;
        }
        if (yl < 0) {
            yl = 0;
            yh = size;
        }
        var viewport = [];
        var yy = 0;
        for (var y = yl; y < yh; y++) {
            viewport[yy] = [];
            for (var x = xl; x < xh; x++) {
                var mapEntry = Object.assign({}, this.getAt(x, y));
                if (this.location.x === x && this.location.y === y) {
                    mapEntry.playerIsHere = true;
                }
                viewport[yy].push(mapEntry);
            }
            yy++;
        }
        if (viewport[0].length !== h * 2 || viewport.length !== h * 2) {
            console.error('fu');
        }
        return viewport;
    };
    Map.prototype.safeWrite = function (x, y, type, verbose) {
        if (verbose === void 0) { verbose = false; }
        if (x < 0 || x > this.width - 1 ||
            y < 0 || y > this.height - 1) {
            return;
        }
        if (verbose) {
            console.log('writing', x, y);
        }
        if (!this.data[y][x]) {
            this.data[y][x] = {};
        }
        // nothing can overwrite the void
        if (this.data[y][x].terrain === TerrainTypes_1.TerrainTypes.Void) {
            return;
        }
        this.data[y][x].terrain = type;
    };
    return Map;
}());
exports.default = Map;
